import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { BannerWithIconContainer } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/modalBanner.styles';
import { ConsentDeniedTooltip } from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/ConsentDeniedTooltip';

type Props = {
  consentDenyReason: string;
};
const EmployeeViewEmployeeDeniedBanner = ({ consentDenyReason }: Props) => (
  <BannerWithIconContainer
    themeColor={ThemeColorType.iconGray}
    justifyContent="space-between"
    alignItems="center">
    <div>
      <Text14 themeColor={ThemeColorType.white} semiBold>
        {gettext('You denied the timesheet edits.')}
      </Text14>

      <div>
        <Text14 themeColor={ThemeColorType.white} semiBold>
          {gettext("Pending manager's approval.")}
        </Text14>
      </div>
    </div>

    <ConsentDeniedTooltip consentDenyReason={consentDenyReason} />
  </BannerWithIconContainer>
);

export default EmployeeViewEmployeeDeniedBanner;
